export const fetchNewsPublishedPath = ({
  newsId,
  topicId,
  userId,
  whiteLabelEnabled = false,
  flagEvNewsRevamp = false,
}: {
  flagEvNewsRevamp?: boolean;
  newsId: number | string;
  topicId?: number | null;
  userId?: number | null;
  whiteLabelEnabled?: boolean;
}) => {
  const params = topicId
    ? { topic_id: topicId, format: 'json' }
    : { format: 'json' };

  if (whiteLabelEnabled) {
    if (flagEvNewsRevamp) {
      return Routes.private_frontoffice_news_path(newsId, params);
    }

    return Routes.network_letter_path(newsId, params);
  }

  if (topicId && !userId) {
    if (flagEvNewsRevamp) {
      return Routes.private_publicoffice_topics_news_path(topicId, newsId, {
        format: 'json',
      });
    }

    return Routes.topic_po_news_post_path(topicId, newsId, { format: 'json' });
  }

  if (topicId) {
    if (flagEvNewsRevamp) {
      return Routes.private_frontoffice_topics_news_path(topicId, newsId, {
        format: 'json',
      });
    }

    return Routes.topics_topic_news_path(topicId, newsId, { format: 'json' });
  }

  if (flagEvNewsRevamp) {
    if (userId) {
      return Routes.private_frontoffice_news_path(newsId, params);
    }

    return Routes.private_publicoffice_news_path(newsId, params);
  }

  return Routes.network_letter_path(newsId, params);
};
